const homeUpdates = null

export default homeUpdates;